<template>
  <div class="drug-box">
    <div class="img-item">
      <img src="https://oss.aqdpay.com/appweb/activeimg/nfcNotice/1.png" alt="">
      <div class="gif-box">
        <img src="https://oss.aqdpay.com/appweb/activeimg/nfcNotice/nfc.gif" alt="">
      </div>
    </div>
    <div class="img-item">
      <img src="https://oss.aqdpay.com/appweb/activeimg/nfcNotice/2.png" alt="">
    </div>
    <div v-if="isApp" class="img-item-2">
      <img @click="goNfc" src="https://oss.aqdpay.com/appweb/activeimg/nfcNotice/button.png" alt="">
    </div>
    <div v-if="!isApp" class="img-item-2">
      <img @click="goApp" src="https://oss.aqdpay.com/appweb/activeimg/nfcNotice/button.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isApp: false
    }
  },
  created () {
    if (this.getDevice()) {
      this.isApp = true
    }
  },
  methods: {
    getDevice () {
      const ua = window.navigator.userAgent
      if (ua.indexOf('pkg/bjqd') > -1) {
        return true
      }
      return false
    },
    goNfc () {
      const data = {
        addToolbar: 1,
        appId: '100299999',
        authorize: 0,
        androidGoPage: '/ReactNative/QDTHomeActivity',
        iosGoPage: 'QDTViewController',
        appType: 0,
        appStartUrl: 'NfcHome'
      }
      dsBridge.call('callNativeViewLifeCycle', {
        ...data
      })
    },
    goApp () {
      if (window._czc) {
        window._czc.push(['_trackEvent', '开通乘车卡推广页', '推广nfc乘车卡', '推广nfc乘车卡', '', '032'])
      }
      window.location.href = 'bjqd://'
      setTimeout(function () {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
      }, 1200)
    }
  }
}
</script>
<style lang="scss" scoped>
.drug-box {
  box-sizing: border-box;
  min-height: 100vh;
  padding-bottom: 20px;
  font-size: 0;
  background: #7fb6ff;
}
.img-item {
  position: relative;
  img {
    width: 100%;
  }
}
.img-item-2 {
  margin: 20px 0;
  padding: 0 20px;
  img {
    width: 100%;
  }
}
.gif-box {
  position: absolute;
  bottom: 8%;
  left: 15%;
  width: 70%;
  margin: 0 auto;
  img {
    width: 100%;
  }
}
</style>
